import { useStore } from 'dg-web-shared/lib/Flux.tsx';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';
import * as TomState from '../state/TomState.ts';
import { localeCompare } from 'dg-web-shared/lib/String.ts';
import { ParsedTom } from 'dg-web-shared/model/Tom.ts';
import {
    NumberMultiSelectionSlideIn,
    Option,
} from '../../ui/slidein/MultiSelectionSlideIn.tsx';
import { tomFilterTexts } from '../i18n/TomTexts.ts';
import { Language } from 'dg-web-shared/lib/Localized.ts';

export interface TomFilter {
    selectedToms: number[];
}

function getDisplayText(tom: ParsedTom, language: Language): string {
    const texts = tomFilterTexts[language];
    return tom.dismantledAtDate
        ? `${tom.operatorExternalId || tom.tomId} - ${
              tom.name
          } - ${texts.dismantled()}`
        : `${tom.operatorExternalId || tom.tomId} - ${tom.name}`;
}

export function TomFilterHalfSlideIn({
    filter,
    open,
    setSelection,
    onClose,
    title,
}: {
    filter: TomFilter;
    open: boolean;
    setSelection: (selectedToms: number[]) => void;
    onClose: () => void;
    title: string;
}) {
    const { storeState } = useStore(store => ({
        toms: TomState.List.get(store),
    }));
    const { language } = useLanguage();

    const options: Option<number>[] = storeState.toms.data
        .filter(tom => tom.lastCollection != null)
        .map((tom: ParsedTom) => {
            return {
                id: tom.tomId,
                displayText: getDisplayText(tom, language),
            };
        })
        .sort((a, b) => localeCompare(a.displayText, b.displayText));

    return (
        <NumberMultiSelectionSlideIn
            open={open}
            heading={title}
            selection={filter.selectedToms}
            options={options}
            setNewSelection={selection => setSelection(selection)}
            onLeftActionClick={() => onClose()}
            outsideBody={false}
        />
    );
}

export function tomSelectionText(
    selectedToms: number[],
    totalTomCount: number,
): string | null {
    if (!selectedToms.length) {
        return null;
    }
    return `${selectedToms.length} / ${totalTomCount}`;
}
